import { Auth } from 'aws-amplify';

const baseURL = import.meta.env.VITE_APP_REPORT_API_BASE_URL;

async function getToken() {
  const currentSession = await Auth.currentSession();
  const { idToken } = currentSession;
  return idToken.jwtToken;
}

function sanitizeUrl(url) {
  // remove the leading slash if there is one
  return url.startsWith('/') ? url.slice(1) : url;
}

export async function getAPI(url, signal = null) {
  const token = await getToken();
  const response = await fetch(`${baseURL}/${sanitizeUrl(url)}`, {
    headers: {
      'x-auth-token': token,
    },
    ...(signal ? { signal } : {}),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
}

export async function postAPI(url, body, signal = null) {
  const token = await getToken();
  const response = await fetch(`${baseURL}/${sanitizeUrl(url)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token,
    },
    body: JSON.stringify(body),
    ...(signal ? { signal } : {}),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
}

export async function putAPI(url, body) {
  const token = await getToken();
  const response = await fetch(`${baseURL}/${sanitizeUrl(url)}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token,
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  try {
    return await response.json();
  } catch (error) {
    console.error('Error parsing JSON response:', error);
    return null; // or handle error as appropriate
  }
}

export async function deleteAPI(url, body) {
  const token = await getToken();
  const response = await fetch(`${baseURL}/${sanitizeUrl(url)}`, {
    method: 'DELETE',
    headers: {
      'x-auth-token': token,
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  if (Number(response.headers.get('Content-Length')) > 0) {
    return response.json();
  }
}
